import script from "./PotasiumClock.vue?vue&type=script&setup=true&lang=js"
export * from "./PotasiumClock.vue?vue&type=script&setup=true&lang=js"

import "./PotasiumClock.vue?vue&type=style&index=0&id=44918bab&lang=css"

const __exports__ = script;

export default __exports__